<template>
    <el-form-item size="large" class="search_compound">
        <el-row :class="focusClass">
            <el-input
                class="keywords"
                v-model="searchComp.value"
                :placeholder="`${$t('publicPart.search.inputPlaceholder')}${$t(
                    'publicPart.search.keyWord'
                )}`"
                maxlength="100"
                size="large"
                style="width: 100%"
                prefix-icon="el-icon-search"
                @focus="setFocus(true)"
                @blur="setFocus(false)"
                @input="search"
                clearable
            >
            </el-input>
        </el-row>
    </el-form-item>
</template>
<script>
export default {
    data() {
        return {
            searchComp: {
                key: "",
                value: "",
            },
            inputSelectList: [],
            isFocus: false,
            focusClass: "",
        };
    },
    methods: {
        search(v) {
            console.log(this.$parent)
            this.$parent.searchForm.keyword = v.replace(/(^ +| +$)/g, "");
            this.$parent.search(1);
        },
        setFocus(isTrue) {
            this.focusClass = isTrue ? "is-focus" : "";
        },
    },
    props: {
        searchList: {
            type: Array,
            default: () => {
                [{ label: "", key: "" }];
            },
        },
        funcName: String,
    },
    watch: {
        searchList: {
            handler(newValue) {
                if (newValue) {
                    this.searchComp.key = newValue[0].key;
                    this.inputSelectList = [];
                    for (let i in newValue) {
                        if (newValue[i].type == "input") {
                            this.inputSelectList.push(newValue[i]);
                        }
                    }
                }
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.search_compound {
    .el-form-item__content {
        width: 96%;
        .el-row {
            // margin-top: 15px;
            border: 2px solid #fff;
            border-radius: 6px;
            .keywords {
                width: 100%;
                input {
                    width: 100%;
                    border-radius: 4px;
                    &:focus {
                        border-color: #c0c6cc;
                    }
                }
            }
            &.is-focus {
                border-color: $color-border-blue;
            }
        }
    }
}
</style>